<div class="position-relative text-grey">
    <div class="modal-header">
      <h4 class="modal-title synchpc-primary" id="modal-title" matTooltip="Update GPO Properties ">Update GPO Properties</h4>
      <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
    </div>
    <div>
      <div class="modal-body">
        <form [formGroup]="form">
          <mat-form-field class="w-100" style="height: 71px; font-size: small;">
            <mat-label style="font-size: 14px;">Select Configuration</mat-label>
            <mat-select formControlName="selectedConfig" style="font-size: 14px;">
              <mat-option *ngFor="let item of configItems" [value]="item.humanReadableName" style="font-size: 14px;">
                {{ item.humanReadableName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      
          <mat-form-field class="w-100" style="height: 71px; font-size: small;">
            <mat-label style="font-size: 14px;">Action</mat-label>
            <mat-select formControlName="action" style="font-size: 14px;">
              <mat-option style="font-size: 14px;" value="1">Enable</mat-option>
              <mat-option style="font-size: 14px;" value="0">Disable</mat-option>
              <mat-option style="font-size: 14px;" disabled value="-1">Not Configured</mat-option>
            </mat-select>
          </mat-form-field>
      
          <p style="font-size: 14px;" *ngIf="selectedItem">Description: {{ selectedItem.description }}</p> 
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
        <button mat-button class="btn btn-primary" color="primary" (click)="onSubmit()" [disabled]="!form.valid">Save</button>
      </div>
    </div>

    <ngx-spinner bdColor="rgba(0,0,0,0)"
    size="default" zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="gpoList"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
